/* The Good Monk — theme behaviours */
(function () {
  'use strict';

  /* ---------------- Product page ---------------- */
  var pSection = document.querySelector('[data-product-section]');
  if (pSection) {
    var dataEl = pSection.querySelector('[data-variant-data]');
    var data = {};
    try { data = JSON.parse(dataEl.textContent); } catch (e) { data = { variants: [] }; }

    var money = function (cents) {
      var fmt = data.moneyFormat || '${{amount}}';
      var amount = (cents / 100);
      var withDec = amount.toFixed(2);
      var noDec = Math.round(amount).toString();
      var comma = function (s) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
      return fmt
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, comma(noDec))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, comma(withDec))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
        .replace(/\{\{\s*amount\s*\}\}/g, withDec);
    };

    var pills = Array.prototype.slice.call(pSection.querySelectorAll('[data-option-value]'));
    var optionCount = pSection.querySelectorAll('.product__option').length;
    var idInput = pSection.querySelector('[data-variant-id]');
    var planInput = pSection.querySelector('[data-selling-plan]');
    var priceEl = pSection.querySelector('[data-price]');
    var packBadge = pSection.querySelector('[data-pack-badge]');
    var addBtn = pSection.querySelector('[data-add-btn]');
    var addLabel = pSection.querySelector('[data-add-label]');
    var subEl = pSection.querySelector('[data-subscribe-price]');
    var oneEl = pSection.querySelector('[data-onetime-price]');

    var getSelected = function () {
      var sel = [];
      for (var i = 0; i < optionCount; i++) {
        var active = pSection.querySelector('.product__option[data-option-index="' + i + '"] .product__pill.is-active');
        sel.push(active ? active.getAttribute('data-value') : null);
      }
      return sel;
    };
    var subscribeMode = function () {
      var r = pSection.querySelector('input[name="purchase_mode"]:checked');
      return r ? r.value === 'subscribe' : false;
    };

    var update = function () {
      var variant;
      if (optionCount === 0) { variant = data.variants[0]; }
      else {
        var sel = getSelected();
        variant = data.variants.find(function (v) {
          return sel.every(function (val, i) { return val == null || v.options[i] === val; });
        });
      }
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      var sub = subscribeMode() && variant.subscribePrice != null;
      var shown = sub ? variant.subscribePrice : variant.price;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (packBadge) packBadge.textContent = (data.volume ? data.volume + ' x ' : '') + (variant.title || '');
      if (subEl && variant.subscribePrice != null) subEl.textContent = money(variant.subscribePrice);
      if (oneEl) oneEl.textContent = money(variant.price);
      if (planInput) {
        var checked = pSection.querySelector('input[name="purchase_mode"]:checked');
        planInput.value = (sub && checked) ? (checked.getAttribute('data-plan-id') || '') : '';
      }
      if (addBtn && addLabel) {
        if (variant.available) { addBtn.disabled = false; addLabel.textContent = money(shown) + ' | Add to cart'; }
        else { addBtn.disabled = true; addLabel.textContent = 'Sold out'; }
      }
    };

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var idx = pill.getAttribute('data-index');
        pSection.querySelectorAll('.product__option[data-option-index="' + idx + '"] .product__pill').forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        update();
      });
    });
    pSection.querySelectorAll('[data-buy-option]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        pSection.querySelectorAll('[data-buy-option]').forEach(function (o) { o.classList.remove('is-active'); });
        opt.classList.add('is-active');
        var radio = opt.querySelector('input[name="purchase_mode"]');
        if (radio) radio.checked = true;
        update();
      });
    });
    // Gallery thumbnails
    var mainImg = pSection.querySelector('[data-main-image]');
    pSection.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (mainImg) mainImg.src = thumb.getAttribute('data-thumb');
        pSection.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
    update();
  }

  // Mobile nav drawer
  var toggle = document.querySelector('[data-nav-toggle]');
  var drawer = document.querySelector('[data-mobile-nav]');
  if (toggle && drawer) {
    toggle.addEventListener('click', function () {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.matches('[data-nav-close]') || e.target === drawer) {
        drawer.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  }

  /* ---------------- Cart drawer ---------------- */
  var DRAWER_SECTION = 'cart-drawer';
  var drawerWrap = document.getElementById('shopify-section-' + DRAWER_SECTION);

  var getDrawer = function () { return document.querySelector('[data-cart-drawer]'); };
  var openDrawer = function () { var d = getDrawer(); if (d) { d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; } };
  var closeDrawer = function () { var d = getDrawer(); if (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; } };

  var updateCounts = function (count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count; if (el.hasAttribute('hidden') && count > 0) el.removeAttribute('hidden');
    });
  };

  // Replace drawer markup with freshly rendered section HTML, keeping it open
  var renderDrawer = function (sectionsHtml, keepOpen) {
    if (drawerWrap && sectionsHtml && sectionsHtml[DRAWER_SECTION]) {
      drawerWrap.innerHTML = sectionsHtml[DRAWER_SECTION];
      if (keepOpen) openDrawer();
    }
  };

  var refreshDrawer = function (keepOpen) {
    return fetch('/?sections=' + DRAWER_SECTION)
      .then(function (r) { return r.json(); })
      .then(function (s) { renderDrawer(s, keepOpen); });
  };

  // Delegated controls (drawer content is replaced on each change)
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }

    var up = e.target.closest('[data-qty-up]');
    var down = e.target.closest('[data-qty-down]');
    var rm = e.target.closest('[data-qty-remove]');
    var ctrl = up || down || rm;
    if (!ctrl) return;
    var line = Number(ctrl.getAttribute('data-line'));
    var row = ctrl.closest('.cart-line');
    var current = row ? Number(row.querySelector('[data-qty-value]').textContent) : 1;
    var qty = rm ? 0 : (up ? current + 1 : Math.max(0, current - 1));
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: [DRAWER_SECTION] })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCounts(cart.item_count);
        renderDrawer(cart.sections, true);
      });
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  // Add to cart (AJAX) — adds item, refreshes drawer, opens it
  document.querySelectorAll('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var idInput = form.querySelector('[name="id"]');
      if (!idInput || !idInput.value) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; }
      var qtyInput = form.querySelector('[name="quantity"]');
      var planInput = form.querySelector('[name="selling_plan"]');
      var payload = { items: [{ id: Number(idInput.value), quantity: qtyInput ? Number(qtyInput.value) || 1 : 1 }], sections: [DRAWER_SECTION] };
      if (planInput && planInput.value) payload.items[0].selling_plan = Number(planInput.value);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          updateCounts(cart.item_count);
          if (btn) { btn.disabled = false; btn.innerHTML = original; }
          return refreshDrawer(true);
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.innerHTML = original; }
          window.location.href = '/cart';
        });
    });
  });
})();
